import React from 'react';
import {useNavigate} from "react-router-dom";
import './WaitValidate.scss';

const WaitValidate: React.FunctionComponent = () => {
    const navigate = useNavigate();

    return (
        <div className="wvPage">
            <div className="wvBg"/>

            <div className="wvCenter">
                <div className="wvCard">
                    <div className="wvCardHeader">
                        <img src={`${process.env.PUBLIC_URL}/logo_fc.svg`} alt="freeCompta" className="wvCardLogoImg"/>
                        <div className="wvCardLogo">
                            <span className="wvCardLogoText">Free Compta</span>
                            <span className="wvCardLogoTag">The Financial Atelier</span>
                        </div>
                    </div>

                    <div className="wvIcon">
                        <span className="material-symbols-outlined">hourglass_empty</span>
                    </div>

                    <h2 className="wvCardTitle">Compte en attente de validation</h2>
                    <p className="wvCardSubtitle">
                        Veuillez attendre la validation du compte par un administrateur. Merci.
                    </p>

                    <button className="wvBtn" onClick={() => navigate("/")}>
                        Connexion
                    </button>

                    <a href="mailto:admin@free-compta.fr" className="wvContact">
                        <span className="material-symbols-outlined">help</span>
                        <span>N'hésitez pas à nous contacter si besoin !</span>
                    </a>
                </div>
            </div>

            <footer className="wvFooter">
                <a href="mailto:admin@free-compta.fr" className="wvFooterLink">Besoin d'aide ?</a>
                <span className="wvFooterDot">•</span>
                <span>© {new Date().getFullYear()} FREECOMPTA.</span>
            </footer>
        </div>
    );
};

export default WaitValidate;
